import Extend from 'flarum/common/extenders';
import ComposerPage from './components/ComposerPage';

export default [
  new Extend.Routes() //
    .add('gbDirectLinksComposer', '/composer', ComposerPage),
];
